module.exports = __webpack_public_path__ + "static/media/img_48.ef0d64ae.png";